import React from "react";
import { connect } from "react-redux";
import { makeMsisdnBeautiful } from "../Utils";
import ChangeEmailForm from "../components/forms/ChangeEmailForm";
import ChangePasswordForm from "../components/forms/ChangePasswordForm";
import { Message } from "../locale/Message";

class MyProfile extends React.Component {
  render() {
    const { userInfo, lang } = this.props;

    return (
      <div className="profile-wrapper container-fluid">
        <div className="row no-gutters justify-content-center">
          <div className="profile col-xs-12 col-sm-8 col-md-7 col-lg-7">
            <section className="profile-form row no-gutters bg-white justify-content-md-center">
              <div className="col-xs-12 col-md-8 col-lg-7">
                <div className="d-flex justify-content-around">
                  <h1 className="text-purple big-char">
                    {userInfo.firstName.charAt(0)}
                  </h1>
                  <div>
                    <h3>
                      {userInfo.lastName} {userInfo.firstName}{" "}
                      {userInfo.middleName}
                    </h3>
                    <p className="mb-1 text-gray">{userInfo.email}</p>
                    <p className="mb-4 text-gray">
                      {makeMsisdnBeautiful(userInfo.msisdn)}
                    </p>
                  </div>
                </div>

                <span className="t3 t-light">{Message.profileInfo[lang]}</span>

                <hr className="mt-5 mb-5" />
                <h4 className="title">{Message.changeEmail[lang]}</h4>
                <div className="mt-2">
                  <ChangeEmailForm lang={lang} />
                </div>

                <hr className="mt-5 mb-5" />
                <h4 className="title">{Message.changePassword[lang]}</h4>
                <div className="mt-2">
                  <ChangePasswordForm lang={lang} />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  lang: state.lang,
  userInfo: state.userInfo,
}))(MyProfile);
